import $ from "jquery";
import React from "react";
import moment from "moment";
import { LenguageTabla } from "../../Comunes/LenguajeTabla/LenguajeTabla";
import ReactDOM from "react-dom";
import { withRouter } from "react-router-dom";
import servicioUsuario from "../../../servicios/servicioUsuario";
import { nombreDeRol } from "../../../constantes/nombreDeRol";

export class ResultadoConsultaSolicitud extends React.Component {
  constructor(props) {
    super(props);

    this.redireccionarDetalles = this.redireccionarDetalles.bind(this);
    this.focusRef = React.createRef();
  }

  async redireccionarDetalles(data) {
    servicioUsuario.tieneRol(nombreDeRol.PadronConsultarSolicitudes) &&
      this.props.history.push({
        pathname: "/Padron/DetalleSolicitudPadron",
        state: {
          Datos: data,
        },
      });
  }

  async componentDidMount() {
    this.cargarDatatable(this.props.datos, this.props.PaginaInicio);
  }

  componentWillUnmount() {}

  componentDidUpdate(prevProps) {
    if (prevProps.datos !== this.props.datos) {
      this.cargarDatatable(this.props.datos, this.props.PaginaInicio);
    }
  }

  cargarDatatable(datos, start) {
    this.$el = $(this.el);

    $.fn.dataTable.ext.errMode = 'throw';
    $.fn.dataTable.moment("DD/MM/YYYY");

    this.$el.DataTable({
      language: LenguageTabla,
      iDisplayLength: 10,
      displayStart: start,
      processing: true,
      destroy: true,
      stateSave: true,
      data: datos,
      columns: [
        {
          data: null,
          render: function (data) {
            return (
              "<button className='js-detalle' >" +
              data.consecutivo +
              "</button>"
            );
          },
        },
        {
          data: "fecha",
          render: function (data) {
            return data !== null ? moment(data).format("DD/MM/YYYY") : "";
          },
        },
        {
          data: "claseDato.nombreConId",
        },
        {
          data: "entidad.alias",
        },
        {
          data: "tipoSolicitud.nombre",
        },
        {
          data: "estadoSolicitud.nombre",
        },
        {
          data: "idPersonaTramite.tipoPersona.descripcionCorta",
        },
        {
          data: "idPersonaTramite.codigo",
        },
        {
          data: "personaEntidad.nombreCompleto",
        },
        {
          data: "personaEntidad.fechaConstitucionONacimiento",
          render: function (data) {
            return data !== null ? moment(data).format("DD/MM/YYYY") : "";
          },
        },
        {
          data: "personaEntidad.paisRegistroONacimiento.nombrePais",
        },
        {
          data: "personaEntidad.descripcionGenero",
        },
      ],
      order: [[0, "asc"]],
      columnDefs: [
        {
          targets: [0],
          createdCell: (td, cellData, rowData, row, col) => {
            ReactDOM.render(
              <button
                className="btn btn-link"
                onClick={this.redireccionarDetalles.bind(this, cellData)}
              >
                {cellData.consecutivo}
              </button>,
              td
            );
          },
        },
      ],
    });

    localStorage.setItem(
      "parametrosCargadosSolicitud",
      JSON.stringify(this.props.parametrosCargados)
    );
  }

  render() {
    return (
      <div className="card-body">
        <table
          ref={(el) => (this.el = el)}
          id="tbSolicitudesPadron"
          className="table table-striped table-hover display"
        >
          <thead ref={this.focusRef}>
            <tr>
              <th>Número Solicitud</th>
              <th>Fecha Solicitud</th>
              <th>Clase Datos</th>
              <th>Entidad</th>
              <th>Tipo Solicitud</th>
              <th>Estado Solicitud</th>
              <th>Tipo Persona</th>
              <th>Identificación</th>
              <th>Nombre / Razón Social</th>
              <th>Fecha Nac./Const.</th>
              <th>País Nac./Reg.</th>
              <th>Género</th>
            </tr>
          </thead>
        </table>
      </div>
    );
  }
}

export default withRouter(ResultadoConsultaSolicitud);
